export const SET_LOADING = 'setLoading';